export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "灼见社的报道内容都是真实发生的吗？",
    a: "灼见社坚持多方信源交叉核验的采编流程。每一篇独家报道在发布前都会经过信源复核、事实核查与内部审稿三道程序。我们也鼓励当事人或知情方对内容提出异议，经核实后将及时更正或补充说明。",
  },
  {
    q: "我掌握了一些线索，应该如何安全地提供给你们？",
    a: "你可以通过站内邮箱与我们取得联系，并注明线索类型与可公开的联系方式。我们尊重每一位信源的安全与隐私，可根据你的要求对身份信息进行脱敏处理，是否署名、如何署名都由你来决定。",
  },
  {
    q: "你们会报道所有收到的'爆料'吗？",
    a: "不会。在正式成稿前，我们会先评估线索的真实性、可核验程度与公共利益相关性。对于缺乏实证支撑、可能侵犯他人合法权益或明显不实的传闻，我们宁可暂时搁置，也绝不为了流量而抢先发布。",
  },
  {
    q: "深度报道的栏目是如何划分的？",
    a: "我们按内容领域划分为娱乐圈内幕、互联网背后、商业资本、科技幕后、民生观察与都市异闻六个栏目。你可以在顶部导航或栏目页中按兴趣浏览，每篇文章也配有清晰的标签便于检索。",
  },
  {
    q: "订阅邮件会推送哪些内容？频率如何？",
    a: "订阅用户会优先收到每周的重点独家报道与深度长文推荐，不包含无关广告。你可以随时在邮件底部一键退订，我们承诺绝不会把你的邮箱用于订阅之外的任何用途。",
  },
];